import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  ArrowUp,
  ChevronDown,
  ChevronUp,
  CirclePlus,
  MoreVertical,
  SquarePen,
} from "lucide-react";
import EditServiceCharge from "pages/GenericOrderDetailsPage/components/edit_service_charge";
import EditRateQuantityModal from "pages/GenericOrderDetailsPage/components/EditRateQuantityModal";
import { Milestone, OrderDetailResponse } from "pages/GenericOrderDetailsPage/types/order";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { formatCurrency } from "utils";
import DiscountEditDialog from "../AmountCharges/DiscountEditDialog";
import AddCurrencyDialog from "./AddCurremcy";
import AssignPrepaidCardDialog from "./AssignCard";
import UpdateOrderDialog from "./UpdateProduct";
import TCSEditDialog from "pages/GenericOrderDetailsPage/components/tcs/TCSEditDialog";
import useOrderStageStatus from "pages/GenericOrderDetailsPage/hooks/useOrderStageStatus";

export default function ProductAndCharges({
  orderdetails,
  disCountinfo,
  isDisabled,
  milestones,
  orderType,
  deliveryData,
  isInvoiceAvalaible
}: {
  orderdetails: OrderDetailResponse;
  disCountinfo: any;
  payable?: any;
  paid?: any;
  isDisabled?: boolean;
  milestones?: Milestone[];
  orderType?: string;
  deliveryData: any;
  isInvoiceAvalaible: boolean
}) {
  const id = useParams().id as string;
  const OtherChargesVal = orderdetails?.overview?.amount_and_charges;
  const [openCouponModal, setOpenCouponModal] = useState<boolean>(false);
  const [showCharges, setShowCharges] = useState<boolean>(false);
  const [showGSTDetails, setShowGSTDetails] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isCurrencyDialogOpen, setIsCurrencyDialogOpen] = useState(false);
  const [isUpdatedProduct, setIsUpdatedProduct] = useState<boolean>(false);
  const [prodcutTypeFlow, setProductTypeFlow] = useState<string>("Card");
  const [selectProductTypeList, setSelectProductTypeList] = useState<any>(null)

  const {
    completedStages,
    getAllButtonStates
  } = useOrderStageStatus(milestones || []);

  const handleOpen = () => {
    setOpenCouponModal(!openCouponModal);
  };

  const handleAssignCard = () => {
    setOpen(true);
  };
  const getAmount = (value: unknown): number | null => {
    if (value === null || value === undefined) return null;
    const parsed =
      typeof value === "number"
        ? value
        : typeof value === "string"
          ? Number(value)
          : NaN;
    return Number.isFinite(parsed) ? parsed : null;
  };

  const formatAmount = (value: unknown): string => {
    const amount = getAmount(value);
    return amount !== null ? amount.toFixed(2) : "0.00";
  };


  const discountAmountValue = disCountinfo?.amount_discounted;
  const gstCharges = OtherChargesVal?.margins_and_charges?.GST ?? {};
  const gstTotalFormatted = formatAmount(gstCharges?.GST);
  const cgstAmount = getAmount(gstCharges?.CGST);
  const sgstAmount = getAmount(gstCharges?.SGST);
  const igstAmount = getAmount(gstCharges?.IGST);
  const hasStateGST = cgstAmount !== null && sgstAmount !== null;

  const processedProducts = useMemo(() => {
    const products = orderdetails?.overview?.products || [];
    const onlyAcceptedProducts = products.filter(p => p.status !== 'Reject');

    return onlyAcceptedProducts.map((product) => {
      const fcyAmount = product.fx_amount || 0;
      const inrAmount = product.inr_amount || 0;
      const quantity = product.quantity || 1;
      const currencyWant = orderType === 'sell' ?  product.country_currency_have || "" : product.country_currency_want || "";
      const currencyHave = orderType === 'sell' ? product.country_currency_want || "" : product.country_currency_have || "";
      const rate = product.rate_and_margins?.[0]?.ibr_rate || 0;
      const customer = product.created_for || "";


      return {
        id: product.id,
        name: product.name || "",
        subCategory: product.subCategory || "",
        fcyAmount:
          fcyAmount > 0
            ? `${currencyWant} ${fcyAmount.toFixed(2)}`
            : `${currencyWant} ${((inrAmount / rate) * quantity).toFixed(2)}`,
        customerRate: `${currencyHave} ${rate > 0 ? rate.toFixed(2) : (inrAmount / quantity).toFixed(2)
          }`,
        inrAmount: inrAmount,
        quantity: quantity,
        status: product.status || "",
        currencyWant,
        currencyHave,
        rate: rate || inrAmount / quantity,
        customer,
        product_id: product.product_id || 0,
      };
    });
  }, [orderdetails?.overview?.products]);

  const groupedCardProducts = processedProducts.reduce((acc, product) => {
    const cardProducts = [16, 35, 36]
    const key = cardProducts.includes(product.product_id) ? 'card' : 'currency';
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(product);
    return acc;
  }, {} as Record<string, typeof processedProducts>);

  const cardDetailsWithProducts = Object.entries(groupedCardProducts).map(
    ([type, products]) => {
      const onlyAcceptedProducts = products.filter((p) => p.status !== "Reject");
      const firstProductId = onlyAcceptedProducts?.[0]?.id ?? null;

      if (type === "card") {
        return {
          id: firstProductId,
          type: "card",
          cardInfo: orderdetails?.card_details || null,
          products: onlyAcceptedProducts || [],
        };
      }

      return {
        id: firstProductId,
        products: onlyAcceptedProducts || [],
      };
    }
  );

  const customerId = orderdetails?.metadata?.customer_id;

  return (
    <div className="w-full ">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm">
          <div className="p-3">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg font-bold text-[#333333] leading-[140%] tracking-[0.02rem]">
                Products {JSON.stringify(isDisabled)}
              </h2>
            </div>

            {/* Table Header */}
            <div className="grid grid-cols-3 text-sm font-medium text-[#666666] leading-[14px] border-b pb-3 bg-[#EEEEEE] p-[14px] rounded-tl-[8px] rounded-tr-[8px]">
              <div className=" flex items-center gap-2">
                Product
                <ArrowUp className="w-4 h-4" />
              </div>
              <div className="">FCY Amount</div>
              <div className="">Customer rate</div>
              <div className=""></div>
            </div>

            {processedProducts?.length > 0 ? (
              cardDetailsWithProducts?.map((product, key) => {
                if (product.type === 'card') {
                  const cardAssigned = product.cardInfo !== null;
                  const assignCard = product.cardInfo;
                  return (
                    <div key={key} className="grid grid-cols-3 gap-4 items-start py-3 border-b border-gray-100">
                      <div className=" place-content-start">

                        {cardAssigned ? (
                          <div className="">
                            <div className="w-full rounded-[8px]">

                              <div className="bg-[#F4F8FF] p-4 rounded-[10px] shadow-sm relative">
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  disabled={
                                    getAllButtonStates?.disableAll?.disabled ||
                                    !completedStages.includes("Order Accepted") ||
                                    // disable if any product in this card group has a deliveryData entry with a non-pending status
                                    product?.products?.some((p: any) =>
                                      deliveryData?.some(
                                        (d: any) =>
                                          (d.product_id === p.product_id || d.product_id === p.id) &&
                                          d.status !== "Pending"
                                      )
                                    )
                                  }
                                  onClick={handleAssignCard}
                                  className="absolute top-2 right-2 p-1 h-auto text-blue-600 hover:text-blue-800 hover:bg-blue-100 rounded"
                                >
                                  <img src="/images/editicon.svg" alt="edit icon" className="w-4 h-4" />
                                </Button>
                                <div className="font-semibold text-[#262F63]">
                                  {assignCard?.[0]?._forex_card?.[0]?.card_company}

                                </div>
                                <div className="text-xs text-gray-600 mt-1 uppercase">
                                  {assignCard?.[0]?._forex_card?.[0]?.card_type}
                                </div>
                                <div className="mt-2 text-sm text-[#262F63]">
                                  {`No: ${assignCard?.[0]?.card_number}`}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="">
                            <div className="flex flex-col">
                              <Button
                                onClick={handleAssignCard}
                                variant="ghost"
                                disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Order Closed')}
                                className="bg-[#EFF4FF] p-2 rounded-[10px] text-blue-700 font-semibold leading-4 text-sm tracking-normal mt-1"
                              >
                                Assign Card +
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="flex col-span-2 flex-col">
                        {product?.products?.map((product) => (
                          <div
                            key={key}
                            className="flex justify-between items-center py-3 border-b border-gray-100"
                          >
                            <div className=" text-[#333333] text-sm font-medium leading-[16px] tracking-[0px]">
                              {product?.currencyWant} {product?.quantity}
                            </div>
                            <div className=" text-[#333333] text-sm font-medium leading-[16px] tracking-[0px]">
                              {product?.customerRate}
                            </div>
                            <div className="">
                              <Popover>
                                <PopoverTrigger disabled={getAllButtonStates?.disableAll?.disabled} asChild>
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    className="text-gray-400 hover:text-gray-600 p-1 h-auto"
                                  >
                                    <MoreVertical className="w-4 h-4" />
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent
                                  className="w-auto p-0"
                                  align="end"
                                  side="bottom"
                                >
                                  <div className="bg-white border-gray-200 rounded-lg shadow-lg">
                                    <EditRateQuantityModal
                                      currency="INR"
                                      rate={product?.rate}
                                      quantity={product?.quantity}
                                      productId={product.id}
                                      productName={product.name}
                                      oldPayable={OtherChargesVal?.total_payable}
                                    >
                                      <Button
                                        variant="ghost"
                                        className="w-full justify-start gap-2 p-3 text-sm font-normal hover:bg-gray-50 rounded-lg"
                                      >
                                        <img
                                          src="/images/editicon.svg"
                                          alt="edit icon"
                                          className="w-4 h-4"
                                        />
                                        Edit
                                      </Button>
                                    </EditRateQuantityModal>
                                  </div>
                                </PopoverContent>
                              </Popover>
                            </div>
                          </div>
                        ))}
                      </div>
                      {
                        !isInvoiceAvalaible &&
                        <div className="flex w-full justify-end col-span-full">
                          <button
                            disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments')}
                            onClick={() => {
                              setProductTypeFlow("Card");
                              setIsCurrencyDialogOpen(true);
                              setSelectProductTypeList(product?.products)
                            }}
                            className="flex disabled:opacity-40 items-center gap-2 text-sm font-semibold px-3 py-2 mt-4 text-[#333333] transition-colors"
                          >
                            <CirclePlus className="w-4 h-4" />
                            Add Currency
                          </button>
                        </div>
                      }
                    </div>
                  )
                }
                return (
                  <div
                    key={key}
                    className="grid grid-cols-3 gap-4 items-start py-3 border-b border-gray-100"
                  >
                    <div className=" place-content-start">
                      <div className="">
                        <div className="flex flex-col">
                          <div className="pl-3 text-[#333333] font-semibold leading-[16px] tracking-[0px]">
                            Currency Notes
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex col-span-2 flex-col">
                      {
                        product.products?.map((product, idx) => {
                          return (
                            <div key={idx} className="flex justify-between items-center py-3 border-b border-gray-100">
                              <div className=" text-[#333333] text-sm font-medium leading-[16px] tracking-[0px]">
                                {product?.currencyWant} {product?.quantity}
                              </div>
                              <div className=" text-[#333333] text-sm font-medium leading-[16px] tracking-[0px]">
                                {product?.customerRate}
                              </div>
                              <div className="">
                                <Popover>
                                  <PopoverTrigger asChild>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      disabled={getAllButtonStates?.disableAll?.disabled}
                                      className="text-gray-400 hover:text-gray-600 p-1 h-auto"
                                    >
                                      <MoreVertical className="w-4 h-4" />
                                    </Button>
                                  </PopoverTrigger>
                                  <PopoverContent
                                    className="w-auto p-0"
                                    align="end"
                                    side="bottom"
                                  >
                                    <div className="bg-white border-gray-200 rounded-lg shadow-lg">
                                      <EditRateQuantityModal
                                        currency="INR"
                                        rate={product?.rate}
                                        quantity={product?.quantity}
                                        productId={product.id}
                                        productName={product.name}
                                        oldPayable={OtherChargesVal?.total_payable}
                                        disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments') || completedStages.includes('Order Cancelled')}
                                      >
                                        <Button
                                          variant="ghost"
                                          className="w-full justify-start gap-2 p-3 text-sm font-normal hover:bg-gray-50 rounded-lg disabled:opacity-40"
                                          disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments') || completedStages.includes('Order Cancelled')}
                                        >
                                          <img
                                            src="/images/editicon.svg"
                                            alt="edit icon"
                                            className="w-4 h-4"
                                          />
                                          Edit
                                        </Button>
                                      </EditRateQuantityModal>
                                    </div>
                                  </PopoverContent>
                                </Popover>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                    {
                      !isInvoiceAvalaible &&
                      <div className="flex w-full justify-end col-span-full">
                        <button
                          onClick={() => {
                            setProductTypeFlow("Currency");
                            setIsCurrencyDialogOpen(true);
                            setSelectProductTypeList(product?.products);
                          }}
                          disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments')}
                          className="flex disabled:opacity-40 items-center gap-2 text-sm font-semibold px-3 py-2 mt-4 text-[#333333] transition-colors"
                        >
                          <CirclePlus className="w-4 h-4" />
                          Add Currency
                        </button>
                      </div>
                    }
                  </div>
                )
              })
            ) : (
              <div className="text-center py-8 text-gray-500">
                No products found
              </div>
            )}
          </div>
        </div>

        {/* Calculation Section */}
        <div className="">
          <h2 className="text-lg font-semibold text-gray-900 mb-6">
            Calculation
          </h2>

          <div className="px-4 py-5 rounded-[12px] shadow-[0px_4px_4px_2px_#EFF1FB]">
            <div className="mb-6">
              <h3 className="text-[13px] capitalize font-medium text-[#165FE3] mb-3">
                {orderType}
              </h3>
              <div className="space-y-2">
                {processedProducts?.map((product: any) => (
                  <div
                    key={product.id}
                    className="flex justify-between items-center mt-1 mb-[14px] text-sm"
                  >
                    <span className="text-[#8D8D8D]">
                      {product.currencyWant}{" "}
                      <span className="text-[#333] mr-1">
                        {product.quantity}
                      </span>
                      <span className="text-[#5777B2]">@</span>{" "}
                      {product.currencyHave}{" "}
                      <span className="text-[#333] ml-1">
                        {product.rate.toFixed(2)}
                      </span>
                    </span>
                    <div className="flex items-center gap-1">
                      <span className="text-xs text-[#222222] bg-[#F5F5F5] px-[6px] py-1 rounded-[8px]">
                        {product.currencyHave}
                      </span>
                      <span className="text-[#333333] leading-[16px] font-medium text-base">
                        {product.inrAmount.toFixed(2)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="border-t pt-4 mb-6">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm font-medium text-[#333333]">
                  Order Total
                </span>
                <span className="font-medium text-sm tracking-[-0.01rem] leading-[16px] text-[#333333]">
                  <span className="text-[#999]">INR</span>{" "}
                  {orderdetails?.amount_and_charges?.amount_before_tax.toFixed(2)}
                </span>
              </div>
            </div>

            <div className="mb-4">
              <div
                className="flex items-center justify-between mb-2 bg-[#F4F4F4] p-3 rounded-[12px] cursor-pointer"
                onClick={() =>
                  setShowCharges((prev) => {
                    if (prev) {
                      setShowGSTDetails(false);
                    }
                    return !prev;
                  })
                }
              >
                <span className="text-sm text-[#000000]">
                  Additional charges
                </span>
                {showCharges ? (
                  <ChevronUp className="w-4 h-4 text-[#000000]" />
                ) : (
                  <ChevronDown className="w-4 h-4 text-[#000000]" />
                )}
              </div>
            </div>

            {showCharges && (
              <div className="space-y-3 mb-6">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => setShowGSTDetails((prev) => !prev)}
                >
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">GST</span>
                    {showGSTDetails ? (
                      <ChevronUp className="w-4 h-4 text-gray-400" />
                    ) : (
                      <ChevronDown className="w-4 h-4 text-gray-400" />
                    )}
                  </div>
                  <span className="text-sm font-medium">
                    INR {gstTotalFormatted}
                  </span>
                </div>
                {showGSTDetails && (
                  <div className="pl-6 space-y-2 text-sm text-gray-600">
                    {hasStateGST ? (
                      <>
                        <div className="flex justify-between items-center">
                          <span>CGST</span>
                          <span className="text-sm font-medium text-gray-800">
                            INR {formatAmount(gstCharges?.CGST)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span>SGST</span>
                          <span className="text-sm font-medium text-gray-800">
                            INR {formatAmount(gstCharges?.SGST)}
                          </span>
                        </div>
                      </>
                    ) : (
                      igstAmount !== null && (
                        <div className="flex justify-between items-center">
                          <span>IGST</span>
                          <span className="text-sm font-medium text-gray-800">
                            INR {formatAmount(gstCharges?.IGST)}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                )}

                {orderType !== 'sell' && (
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">TCS</span>
                    <div className="flex items-center gap-1">
                      <span className="text-sm font-medium">
                        INR {OtherChargesVal?.margins_and_charges?.TCS.toFixed(2)}
                      </span>
                      <button className=" disabled:opacity-40" disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Delivery') || completedStages.includes('Order Cancelled')}>
                        <TCSEditDialog
                          tcs={OtherChargesVal?.margins_and_charges?.TCS}
                          id={id}
                          displayName=""
                        />
                      </button>
                    </div>
                  </div>
                )}

                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">
                    Delivery Charges
                  </span>
                  <div className="flex items-center gap-1">
                    <span className="text-sm font-medium">
                      INR{" "}
                      {orderType === 'sell' ? '-' : ''}
                      {OtherChargesVal?.margins_and_charges?.service_charge?.amount?.toFixed(
                        2
                      )}
                    </span>
                    <Button className="p-0" disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments') || completedStages.includes('Order Cancelled')} variant="ghost">
                      <EditServiceCharge
                        currency="INR"
                        quantity={Number(
                          OtherChargesVal?.margins_and_charges?.service_charge
                            ?.amount
                        )}
                      >
                        <Button className="p-0" variant="ghost">
                          <SquarePen className="w-4 h-4 text-blue-700" />
                        </Button>
                      </EditServiceCharge>
                    </Button>
                  </div>
                </div>                

                <div className="flex flex-col justify-between">
                  <div className="flex justify-between items-center w-full">
                    <div className="flex items-center gap-2 text-sm text-[#666666]">
                      <span>Discount %</span>
                      <button
                        onClick={handleOpen}
                        className="p-1 disabled:opacity-40 hover:bg-gray-100 rounded transition-colors"
                        aria-label={
                          open
                            ? "Hide discount options"
                            : "Show discount options"
                        }
                      >
                        {open ? (
                          <ChevronUp size={14} />
                        ) : (
                          <ChevronDown size={14} />
                        )}
                      </button>
                    </div>

                    <div className="flex flex-row items-baseline gap-2">
                      <span className="text-sm font-medium text-red-600">
                        -
                        {formatCurrency(
                          Number(disCountinfo?.amount_discounted),
                          "INR"
                        )}
                      </span>
                    </div>
                  </div>

                  {openCouponModal && (
                    <div className="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-200 transition-all duration-200 ease-in-out">
                      <DiscountEditDialog
                        couponCode={
                          disCountinfo?.discount_coupon_id?.[0]?.coupon_name ||
                          ""
                        }
                        couponCodeID={disCountinfo?.discount_coupon_id?.[0]?.id}
                        onSave={(newCode) => {
                          console.log("Apply new code:", newCode);
                        }}
                        couponinfoDetails={
                          disCountinfo?.discount_coupon_id?.[0]
                        }
                        genericOrderId={Number(id)}
                        amountBeforeTax={orderdetails?.amount_and_charges.amount_before_tax.toString()}
                        orderTotal={
                          orderdetails?.amount_and_charges.amount_before_tax
                        }
                        discountAmount={discountAmountValue}
                        disabled={getAllButtonStates?.disableAll?.disabled || !completedStages.includes('Order Accepted') || completedStages.includes('Payments')}
                      />
                    </div>
                  )}
                </div>

                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">
                    Round off
                  </span>
                  <div className="flex items-center gap-1">
                    <span className="text-sm font-medium">
                      INR{" "}
                      {OtherChargesVal?.margins_and_charges?.GST?.round_off?.toFixed(
                        2
                      )}
                    </span>                    
                  </div>
                </div>
              </div>
            )}

            <div className="w-full h-[56px] flex justify-between items-center bg-[#e0edff] text-blue-700 mt-5 font-semibold text-sm py-[17px] px-[17px] border-t border-blue-300 rounded-br-[12px] rounded-bl-[12px]">
              <span className="text-base font-600 text-[#165FE3]">
                Grand Total
              </span>
              <div className="flex items-center gap-1">
                <span className="text-[#fff] text-xs bg-[#165FE3] text-white px-1.5 py-1 rounded-[8px] text-[10px]">
                  INR
                </span>
                <span className="text-[#165FE3] text-base font-medium">
                  {OtherChargesVal?.total_payable.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isCurrencyDialogOpen && (
        <AddCurrencyDialog
          setIsCurrencyDialogOpen={setIsCurrencyDialogOpen}
          prodcutType={"Buy"}
          selectedProductType={prodcutTypeFlow}
          customers_id={orderdetails?.metadata?.customer_id}
          ProdcutList={selectProductTypeList}
        />
      )}
      {isUpdatedProduct && (
        <UpdateOrderDialog setIsUpdateDialogOpen={setIsUpdatedProduct} />
      )}
      {open && (
        <AssignPrepaidCardDialog
          customerId={customerId as number}
          open={open}
          onOpenChange={setOpen}
          defaultTab={orderdetails?.card_details?.[0]?._forex_card?.[0]?.card_type?.toLowerCase() === 'singlecurrency' ? 'activation' : 'activationReload'}
          defaultData={{
            action_type: orderdetails?.card_details?.[0]?._forex_card?.[0]?.card_type?.toLowerCase() === 'singlecurrency' ? 'activation' : 'activationReload',
            card_number: orderdetails?.card_details?.[0]?.card_number || '',
            card_id: orderdetails?.card_details?.[0]?.id || 0,
          }}
        />
      )}
    </div>
  );
}
